import { render, staticRenderFns } from "./QuotesModal.vue?vue&type=template&id=54d1de5d&scoped=true"
import script from "./QuotesModal.vue?vue&type=script&lang=js"
export * from "./QuotesModal.vue?vue&type=script&lang=js"
import style0 from "./QuotesModal.vue?vue&type=style&index=0&id=54d1de5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1de5d",
  null
  
)

export default component.exports